import React from "react";
import "./styles/Portfolio.css";

const portfolioItems = [
  {
    title: "Đedovina",
    description: "Emisije o tradiciji i kulturi Crne Gore",
    imageUrl: "images/djedovina-logo.jpg",
    link: "https://www.youtube.com/playlist?list=PLuvGcegGDHBbuygGtXxhz57A1InqwtoTz",
    icon: "fas fa-tv",
    category: "TV Emisije",
  },
  {
    title: "Sam svoj gazda",
    description: "Serijal koji prati preduzetničke priče i lični razvoj",
    imageUrl: "images/samsvojgazda.jpg",
    link: "https://youtube.com/playlist?list=PLxUgi1p5lOa7qUT0sBul7BjJeSVOgAHuL&si=MdVEmftdjhKnU-Ws",
    icon: "fas fa-briefcase",
    category: "Preduzetništvo",
  },
  {
    title: "Dokumentarni filmovi",
    description: "Zbirka dokumentarnih filmova o našoj baštini",
    imageUrl: "images/dokumentarnifilmovi.jpg",
    link: "https://www.youtube.com/playlist?list=PLuvGcegGDHBY8aolM_Mpqc1f9Gtvsscur",
    icon: "fas fa-film",
    category: "Dokumentarci",
  },
  {
    title: "Skriveni vrhovi sjevera",
    description: "Otkrijte ljepote sjeverne Crne Gore",
    imageUrl: "images/skrivenivrhovisevera.jpg",
    link: "https://www.youtube.com/playlist?list=PLuvGcegGDHBYJ9r3cJdA0c4JzAhvVHp70",
    icon: "fas fa-mountain",
    category: "Turizam",
  },
];

export const Portfolio: React.FC = () => {
  return (
    <>
      <section className="page-header-kontakt"></section>

      <section className="portfolio-section">
        <div className="container">
          <div className="section-heading-wrapper">
            <div className="row">
              <div className="col-sm-12 text-center">
                <div className="section-icon">
                  <i className="fas fa-play-circle"></i>
                </div>
                <h2 className="section-heading-inline">
                  Pogledajte našu kolekciju emisija i dokumentarnih filmova o
                  tradiciji i kulturi Crne Gore.
                </h2>
                <p className="section-subtitle">
                  Istražite bogatu kulturnu baštinu Crne Gore kroz naše
                  jedinstvene produkcije.
                </p>
              </div>
            </div>
          </div>

          <div className="portfolio-grid">
            {portfolioItems.map((item, index) => (
              <div className="portfolio-item" key={index}>
                <a href={item.link} target="_blank" rel="noopener noreferrer">
                  <img
                    src={item.imageUrl}
                    alt={item.title}
                    className={`img-fluid ${item.title === "Sam svoj gazda" ? "img-sam-svoj-gazda" : ""}`}
                  />
                  <div className="portfolio-overlay"></div>
                  <div className="play-button">
                    <i className="fas fa-play"></i>
                  </div>
                  <div className="category-badge">
                    <i className={item.icon}></i>
                    <span>{item.category}</span>
                  </div>
                  <div className="portfolio-caption">
                    <div className="caption-header">
                      <i className={`${item.icon} caption-icon`}></i>
                      <h4>{item.title}</h4>
                    </div>
                    <p>{item.description}</p>
                    <div className="caption-footer">
                      <span className="watch-text">
                        <i className="fas fa-external-link-alt"></i>
                        Pogledaj sada
                      </span>
                    </div>
                  </div>
                </a>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};
